<template>
  <v-container>
    <v-data-table
      :no-data-text="$tc('editRegistrations.notData')"
      class="elevation-3 dataTable px-4 mt-5"
      :items-per-page="itemsPerPage"
      :headers="headers"
      :items="items"
      :loading-text="$tc('editRegistrations.loadingItems')"
      :loading="loader"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <div
          style="display: flex; flex-direction: row; justify-content: center"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-row>
                  <v-col class="center">
                    <v-icon
                      small
                      id="icon-edit"
                      class="ml-n2 mr-2"
                      @click="openEdit(item)"
                    >
                      fa-pen
                    </v-icon>
                  </v-col>
                </v-row>
              </span>
            </template>
            <span>{{ $tc("editRegistrations.edit") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-row>
                  <v-col class="center">
                    <v-icon
                      small
                      id="icon-delete"
                      class="ml-2"
                      @click="openDelete(item)"
                    >
                      fa-trash
                    </v-icon>
                  </v-col>
                </v-row>
              </span>
            </template>
            <span>{{ $tc("editRegistrations.delete") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-row>
                  <v-col>
                    <v-icon
                      v-show="action"
                      small
                      color="accent"
                      class="ml-4"
                      @click="openAction(item)"
                    >
                      fa-plus
                    </v-icon>
                  </v-col>
                </v-row>
              </span>
            </template>
            <span>{{ $tc("assignCards.seeBookingErrors") }}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:[`item.tools`]="{ item }">
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <div class="center">
                  <v-icon
                    v-show="tool"
                    small
                    color="accent"
                    class="mt-2 ml-3"
                    @click="repairErrors(item)"
                  >
                    fa-hammer
                  </v-icon>
                </div>
              </span>
            </template>
            <span>{{ $tc("assignCards.repairErrors") }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  props: {
    headers: Array,
    items: Array,
    openEdit: Function,
    openDelete: Function,
    loader: Boolean,
    itemsPerPage: Number,
    action: {
      type: Boolean,
      default: false,
    },
    editAction: {
      type: Boolean,
      default: false,
    },
    openAction: Function,
    tool: {
      type: Boolean,
      default: false,
    },
    repairErrors: Function,
  },
  methods: {
    verifyExistingAction(accion) {
      if (typeof localStorage !== "undefined") {
        const asegurables =
          JSON.parse(localStorage.getItem("asegurables")) || [];
        return asegurables.includes(accion);
      }

      return false;
    },
  },
};
</script>

<style scoped>
.dataTable {
  padding: 0px !important;
  width: 100% !important;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}
</style>
